import React from 'react'
import { connect } from 'react-redux'
import { IRootReducerState } from 'state/rootReducer'
import { CountryCode } from '@carsys/enums/country-code'
import { Locales } from '@carsys/enums/locales'
import { LocaleContextProvider } from '@cbgms/base/locale/LocaleContext'
import { useTranslation } from 'react-i18next'

interface MapStateToProps {
  country: CountryCode
}

type Props = MapStateToProps

const mapStateToProps = (state: IRootReducerState): MapStateToProps => ({
  country: state.auth.shop.VisitorCountry || CountryCode.NL
})

const Locale: React.FC<Props> = ({ country, children }) => {
  const { i18n } = useTranslation()

  return (
    <LocaleContextProvider locale={i18n.language as Locales} country={country}>
      {children}
    </LocaleContextProvider>
  )
}

Locale.displayName = 'Locale'

export default connect(mapStateToProps)(Locale)
